const currencies = [
  'USD',
  'GBP',
  'EUR',
  'SEK',
  'CAD',
  'NOK',
  'CHF',
  'RUB',
  'INR',
  'CZK',
  'PLN',
  'AED',
  'AUD',
  'SAR',
  'OMR',
  'QAR',
  'KWD',
  'BHD',
  'BGN',
  'SGD',
  'DKK',
  'RON',
  'NPR',
  'NZD',
  'HKD',
  'MYR',
  'JPY',
  'PHP',
  'COP',
];

export interface ISalaryTimeSpan {
  label: string;
  value: string;
}

const salaryTimeSpans: ISalaryTimeSpan[] = [
  { value: 'PerAnnum', label: 'Per Annum' },
  { value: 'PerMonth', label: 'Per Month' },
  { value: 'PerDay', label: 'Per Day' },
  { value: 'PerHour', label: 'Per Hour' },
];

export const getCurrencies = (): string[] => currencies;

export const getSalaryTimeSpans = (): ISalaryTimeSpan[] => salaryTimeSpans;
